module.exports = __webpack_public_path__ + "img/solution3.4285ef16.png";